import classNames from 'classnames';

type PageContainerProps = {
  children: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
};

export default function PageContainer({
  children,
  fullWidth = false,
  className,
}: PageContainerProps) {
  return (
    <div
      className={classNames(
        fullWidth ? 'w-full px-4' : 'container mx-auto px-4',
        className
      )}
    >
      {children}
    </div>
  );
}
